module.exports = __webpack_public_path__ + "static/media/fifthpicture.06252ff3.png";